module.exports = __webpack_public_path__ + "static/media/003-Asteroid.9d08056b.svg";